import script from "./Metamask.vue?vue&type=script&lang=ts&setup=true"
export * from "./Metamask.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__